import { handleTouchEvents } from '../utilities/touchEvent'

document.addEventListener('DOMContentLoaded', () => {
  handleTouchEvents('[data-mp-block-type="ticker_block"]')
})
